<template>
  <div>
    <div class='table' v-if="!loadingData && serverData">
      <div class='table__item table__item-header without-line0 left-line bottom-line'>№ п/п</div>
      <div class='table__item table__item-header without-line left-line right-line bottom-line'>Показатели</div>
      <div class='table__item table__item-header right-line bottom-line text-center'>за 2020 г</div>
      <div class='table__item table__item-header right-line bottom-line text-center'>за 2021 г</div>
      <div class='table__item table__item-header right-line bottom-line text-center'>за 2022 г</div>
      
      <div style="max-height: 24px"
           class='table__item pa-0 table__item-header without-line2 left-line right-line bottom-line text-center pl-2'>1
      </div>
      <div style="max-height: 24px" class='table__item pa-0 table__item-header bottom-line text-center pr-2'>2
      </div>
      <div style="max-height: 24px" class='table__item pa-0 table__item-header bottom-line left-line text-center'>3
      </div>
      <div style="max-height: 24px" class='table__item pa-0 table__item-header bottom-line left-line text-center'>4
      </div>
      <div style="max-height: 24px"
           class='table__item pa-0 table__item-header bottom-line left-line text-center right-line'>5
      </div>
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        1
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style=" grid-row-start: 3;
  grid-row-end: 4;">
        Средняя численность работников из числа профессорско-преподавательского состава (списочного состава, без внешних
        совместителей)
      </div>
      <div class='table__item bottom-line text-center'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(0,3)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"
        />
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        2
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style=" grid-row-start: 4;
  grid-row-end: 5;">
        Средняя численность работников – внешних совместителей из числа профессорско-преподавательского состава
        (пропорционально фактически отработанному времени)
      </div>
      <div class='table__item bottom-line text-center'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(3,6)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        3
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 5;
  grid-row-end: 6;">
        Средняя численность работников из числа научных работников (списочного состава, без внешних совместителей)
      </div>
      <div class='table__item bottom-line text-center'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(6,9)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        4
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 6;
  grid-row-end: 7;">
        Средняя численность работников – внешних совместителей из числа научных работников (в пересчете на полную
        занятость)
      </div>
      <div class='table__item bottom-line text-center'>человек</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(9,12)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        5
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 7;
  grid-row-end: 8;">
        Объем поступивших за год средств, всего
      </div>
      <div class='table__item bottom-line text-center'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(12,15)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        6
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 8;
  grid-row-end: 9;">
        Общий объем поступивших за год средств по виду деятельности "научные исследования и разработки"
      </div>
      <div class='table__item bottom-line text-center'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(15, 18)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        7
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 9;
  grid-row-end: 10;">
        Общий объем поступивших за год средств бюджетов всех уровней (субсидий) по виду деятельности "научные
        исследования и разработки"
      </div>
      <div class='table__item bottom-line text-center'>тыс.рублей</div>
      <div
        class='table__item bottom-line left-line item-data text-center d-flex flex-row align-center justify-space-between'
        v-for="item in dataFields.slice(18,21)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line bottom-line' style="grid-column-start: 1; grid-column-end: 2;">
        8
      </div>
      <div class='table__item without-line3 without-line-height left-line right-line bottom-line' style="  grid-row-start: 10;
  grid-row-end: 11;">
        Общий объем поступивших за год средств внебюджетных фондов по виду деятельности "научные исследования и
        разработки"
      </div>
      <div class='table__item text-center'>тыс.рублей</div>
      <div class='table__item  left-line item-data text-center d-flex flex-row align-center justify-space-between'
           v-for="item in dataFields.slice(21,24)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          :cell="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div v-else-if="loadingData" class="d-flex flex-row align-center justify-space-between" style="min-width: 150px;">
      <v-progress-linear indeterminate/>
    </div>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
  </div>
</template>

<script>
import FivesTableCell from "@/components/fields/fivesTableCell";
import appealDialog from "@/components/Dialogs/appealForms5_1-4Dialog";
import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "form5_1a",
  mixins: [setAppealFromOneToFourDialog, headerTooltipFunctions, fiveFormsMixin],
  components: {FivesTableCell, appealDialog, tooltipForms5Dialog},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  
  data() {
    return {
      serverData: null,
      loadingData: false,
      loadingMenu: {value: false, id: ''},
      dataFields: [
        {name: "wpppo20Vp2"},
        {name: "wpppo21Vp2"},
        {name: "wpppo22Vp2"},
        {name: "wppps20Vp2"},
        {name: "wppps21Vp2"},
        {name: "wppps22Vp2"},
        {name: "wpnro20Vp2"},
        {name: "wpnro21Vp2"},
        {name: "wpnro22Vp2"},
        {name: "wpnrs20Vp2"},
        {name: "wpnrs21Vp2"},
        {name: "wpnrs22Vp2"},
        {name: "deorg20Vp2"},
        {name: "deorg21Vp2"},
        {name: "deorg22Vp2"},
        {name: "denir20Vp2"},
        {name: "denir21Vp2"},
        {name: "denir22Vp2"},
        {name: "desbs20Vp2"},
        {name: "desbs21Vp2"},
        {name: "desbs22Vp2"},
        {name: "devbt20Vp2"},
        {name: "devbt21Vp2"},
        {name: "devbt22Vp2"}
      ]
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
  },
  created() {
    this.appealInfo.nameForm = 'FORM5_1A'
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm('part1a', false, false, this.chosenChildOrg?.id);
        this.loadingData = false;
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Нет данных',
          timeout: 5000
        })
        this.loadingData = false;
      }
    },
    calcPropsForCell(dataField) {
      return {
        value: this.serverData[dataField],
        title: '',
        cell: {dataField: dataField},
        id: this.serverData.id,
        row: this.serverData,
        loading: this.loading,
        template: (v) => {
          if (v == null || v === 'н.д.')
            return 'н.д.';
          const dot = v.indexOf(',');
          if (dot !== -1) {
            const newV = v.slice(0, dot) + '.' + v.slice(dot + 1, dot + 2);
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(newV));
          } else
            return Intl.NumberFormat('ru-RU').format(Number.parseFloat(v));
        }
      }
    },
    saveValue(e) {
      this.serverData[e.dataField] = {
        oldValue: e.oldValue,
        newValue: e.newValue,
        id: e.id,
        accept: e.accept
      };
      this.$refs["appeal-dialog"].closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-columns: 150px 1fr 1fr 100px minmax(100px, 200px) minmax(100px, 200px) minmax(100px, 200px);
  margin: auto;
  grid-auto-rows: minmax(10px, auto);
  color: #89A0B0;
  background-color: #FFFFFF;
  border-radius: 6px;
  box-shadow: 0px 6px 18px rgb(0 0 0 / 6%);
  padding: 6px;
  overflow: auto;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
}

.table__item-header {
  font-size: 12px;
}

.table__item {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #CFD8DC;
  
  &:not(.table__item-header) {
    color: #455A64
  }
}

.table__header {
  border-top: 1px solid #CFD8DC;
}

.without-line0 {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;
}

.without-line {
  grid-column-start: 2;
  grid-column-end: 5;
}

.without-line2 {
  grid-column-start: 2;
  grid-column-end: 4;
}

.without-line3 {
  grid-column-start: 2;
  grid-column-end: 4;
}

.without-line-height {
  grid-row-start: 3;
  grid-row-end: 5;
}

.without-line4 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 5;
  grid-row-end: 7;
}

.top-line {
  border-top: none;
}

.left-line {
  border-left: none;
}

.bottom-line {
  border-bottom: none;
}

.right-line {
  border-right: none;
}

.close {
  top: 95px;
  right: 90px;
}

.old__item {
  text-decoration: line-through;
  font-size: 35px;
}

.new__item {
  background: #E3EFFA;
  border-radius: 7px;
  height: 35px;
  width: 190px;
  padding-left: 20px;
  padding-right: 20px;
}

.new__item::placeholder {
  font-size: 20px;
  align-items: center;
}

.items {
  display: flex;
  justify-content: space-between;
  padding: 0px 120px;
  margin-top: 13%;
}

.item-data:hover {
  background: rgba(207, 224, 236, 0.42);
}
</style>